import React from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { List, ListItem, colors } from '@material-ui/core';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import DraftsIcon from '@material-ui/icons/Drafts';
import SendIcon from '@material-ui/icons/Send';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import RemoveIcon from '@material-ui/icons/Remove';


const useStyles = makeStyles(theme => ({
  root: {},
  item: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0
  },
  button: {
    color: colors.blueGrey[800],
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    fontWeight: theme.typography.fontWeightMedium
  },
  icon: {
    color: theme.palette.icon,
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1)
  },
  active: {

    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium,
    '& $icon': {
      color: theme.palette.primary.main
    }
  },
  toleft: {
    paddingLeft: "35px"
  },
  noPadding: {
    padding: "8px 0"
  },
  selected: {
    background: "rgba(120,120,120, 0.5)",
    marginBottom: "8px"
  }
}));



const SidebarNav = props => {
  const { className, ...rest } = props;
  const [open, setOpen] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const [open3, setOpen3] = React.useState(false);
  const classes = useStyles();

  return (
    <List
      {...rest}
      className={clsx(classes.root, className)}
    >
      <ListItem className={open ? (classes.noPadding, classes.selected) : classes.noPadding} button onClick={() => { setOpen(!open) }}>
        <ListItemIcon style={{ "minWidth": "0", "paddingLeft": "10px" }}>
          <RemoveIcon style={{ "color": "white" }} />
        </ListItemIcon>
        <ListItemText primary={<b style={{ "color": "white" }}>Dashboard</b>} />
        {open ? <ExpandLess style={{ "color": "white" }} /> : <ExpandMore style={{ "color": "white" }} />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding style={{ "background": "rgba(120,120,120, 0.5)" }}>
          <ListItem button className={classes.nested, classes.toleft}
            component={RouterLink} to="/dashboard"
          >

            <ListItemText primary={<b style={{ "color": "white" }}>Management</b>} />
          </ListItem>
          <ListItem button className={classes.nested, classes.toleft}
            component={RouterLink} to="/dashboard">

            <ListItemText primary={<b style={{ "color": "white" }}>TV</b>} />
          </ListItem>
        </List>
      </Collapse>

      <ListItem button component={RouterLink} className={classes.noPadding} to="/orders">
        <ListItemIcon style={{ "minWidth": "0", "paddingLeft": "10px" }}>
          <RemoveIcon style={{ "color": "white" }} />
        </ListItemIcon>
        <ListItemText primary={<b style={{ "color": "white" }}>Պատվերներ</b>} />
      </ListItem>

      <ListItem button component={RouterLink} className={classes.noPadding} to="/dashboard">
        <ListItemIcon style={{ "minWidth": "0", "paddingLeft": "10px" }}>
          <RemoveIcon style={{ "color": "white" }} />
        </ListItemIcon>
        <ListItemText primary={<b style={{ "color": "white" }}>Բարձումներ</b>} />
      </ListItem>

      <ListItem button to="/users" component={RouterLink} className={classes.noPadding} to="/plans">
        <ListItemIcon style={{ "minWidth": "0", "paddingLeft": "10px" }}>
          <RemoveIcon style={{ "color": "white" }} />
        </ListItemIcon>
        <ListItemText primary={<b style={{ "color": "white" }}>Պլաններ</b>} />
      </ListItem>

      <ListItem button component={RouterLink} className={classes.noPadding} to="/qrcodes">
        <ListItemIcon style={{ "minWidth": "0", "paddingLeft": "10px" }}>
          <RemoveIcon style={{ "color": "white" }} />
        </ListItemIcon>
        <ListItemText primary={<b style={{ "color": "white" }}>QR կոդեր</b>} />
      </ListItem>

      <ListItem button component={RouterLink} className={classes.noPadding} to="/warehouse">
        <ListItemIcon style={{ "minWidth": "0", "paddingLeft": "10px" }}>
          <RemoveIcon style={{ "color": "white" }} />
        </ListItemIcon>
        <ListItemText primary={<b style={{ "color": "white" }}>Պահեստ</b>} />
      </ListItem>

      <ListItem button onClick={() => setOpen2(!open2)} className={open2 ? (classes.noPadding, classes.selected) : classes.noPadding}>
        <ListItemIcon style={{ "minWidth": "0", "paddingLeft": "10px" }}>
          <RemoveIcon style={{ "color": "white" }} />
        </ListItemIcon>
        <ListItemText primary={<b style={{ "color": "white" }}>Հաշվետվություններ</b>} />
        {open2 ? <ExpandLess style={{ "color": "white" }} /> : <ExpandMore style={{ "color": "white" }} />}
      </ListItem>
      <Collapse in={open2} timeout="auto" unmountOnExit>
        <List component="div" disablePadding style={{ "background": "rgba(120,120,120, 0.5)" }}>
          <ListItem button className={classes.nested, classes.toleft}>

            <ListItemText primary={<b style={{ "color": "white" }}>Պատվերների հետևում</b>} />
          </ListItem>
          <ListItem button className={classes.nested, classes.toleft}>

            <ListItemText primary={<b style={{ "color": "white" }}>Բարձումների հետևում</b>} />
          </ListItem>
          <ListItem button className={classes.nested, classes.toleft}>

            <ListItemText primary={<b style={{ "color": "white" }}>Պլանների հետևում</b>} />
          </ListItem>
          <ListItem button className={classes.nested, classes.toleft}>

            <ListItemText primary={<b style={{ "color": "white" }}>Արտադրանքի հետևում</b>} />
          </ListItem>
          <ListItem button className={classes.nested, classes.toleft}>

            <ListItemText primary={<b style={{ "color": "white" }}>Գործարքների պատմություն</b>} />
          </ListItem>
        </List>
      </Collapse>

      <ListItem button onClick={() => setOpen3(!open3)} className={open3 ? (classes.noPadding, classes.selected) : classes.noPadding} >
        <ListItemIcon style={{ "minWidth": "0", "paddingLeft": "10px" }}>
          <RemoveIcon style={{ "color": "white" }} />
        </ListItemIcon >
        <ListItemText primary={<b style={{ "color": "white" }}>Տեղեկատու</b>} />
        {open3 ? <ExpandLess style={{ "color": "white" }} /> : <ExpandMore style={{ "color": "white" }} />}
      </ListItem>

      <Collapse in={open3} timeout="auto" unmountOnExit>
        <List component="div" disablePadding style={{ "background": "rgba(120,120,120, 0.5)" }}>
          <ListItem button className={classes.nested, classes.toleft}
            component={RouterLink} to="/users">

            <ListItemText primary={<b style={{ "color": "white" }}>Օգտագործողներ</b>} />
          </ListItem>
          <ListItem button className={classes.nested, classes.toleft}
            component={RouterLink} to="/storabajanum">

            <ListItemText primary={<b style={{ "color": "white" }}>Ստորաբաժանումներ</b>} />
          </ListItem>
          <ListItem button className={classes.nested, classes.toleft}
            component={RouterLink} to="/products">

            <ListItemText primary={<b style={{ "color": "white" }}>Արտադրանք</b>} />
          </ListItem>
          <ListItem button className={classes.nested, classes.toleft}
            component={RouterLink} to="/productStatuses">

            <ListItemText primary={<b style={{ "color": "white" }}>Արտադրանքի կարգավիճակներ</b>} />
          </ListItem>
          <ListItem button className={classes.nested, classes.toleft}
            component={RouterLink} to="/partners">

            <ListItemText primary={<b style={{ "color": "white" }}>Գործընկերներ</b>} />
          </ListItem>
          <ListItem button className={classes.nested, classes.toleft}
            component={RouterLink} to="/accesses">

            <ListItemText primary={<b style={{ "color": "white" }}>Իրավասություններ</b>} />
          </ListItem>
          <ListItem button className={classes.nested, classes.toleft}
            component={RouterLink} to="/sizes">

            <ListItemText primary={<b style={{ "color": "white" }}>Չափսեր</b>} />
          </ListItem>

        </List>
      </Collapse>
    </List >
  );
};

SidebarNav.propTypes = {
  className: PropTypes.string
};

export default SidebarNav;
